$(document).ready(function () {
    $(window).resize(function () {
        resizeTestimonials();
    });
    resizeTestimonials();
});

function resizeTestimonials() {
    $('.testimonialVertical').each(function (index, div) {
        var testimonialImageWrapDiv = $(div).find('.testimonial_imageWrap');
        var width = testimonialImageWrapDiv.width();
        if (width > 250) {
            $(testimonialImageWrapDiv).width(250);
            width = 250;
        }
        $(testimonialImageWrapDiv).height(width);
    });
    $('.testimonialHorizontal').each(function (index, div) {
        var testimonialImageWrapDiv = $(div).find('.testimonial_imageWrap');
        var height = testimonialImageWrapDiv.height();
        if (height > 250) {
            $(testimonialImageWrapDiv).height(250);
            height = 250;
        }
        $(testimonialImageWrapDiv).width(height);
    });
}